import React from "react";
import { PhoneIcon, MailIcon } from "./HelpCenterIcons";

const HelpCenterContactInfo = () => {
  return (
    <div className="v2-help-pg-card">
      <div className="v2-help-pg-card__header">
        <div className="v2-help-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
          <PhoneIcon size={20} color="#eb1414" />
        </div>
        <div>
          <h3 className="v2-help-pg-card__title">Contact Info</h3>
        </div>
      </div>

      <div className="v2-help-pg-contact-list">
        <div className="v2-help-pg-contact-item">
          <MailIcon size={18} color="#9ca3af" />
          <div className="v2-help-pg-contact-item__text">
            <span className="v2-help-pg-contact-item__label">Email</span>
            <span className="v2-help-pg-contact-item__value">support@wtfgyms.com</span>
          </div>
        </div>
        <div className="v2-help-pg-contact-item">
          <PhoneIcon size={18} color="#9ca3af" />
          <div className="v2-help-pg-contact-item__text">
            <span className="v2-help-pg-contact-item__label">Phone</span>
            <span className="v2-help-pg-contact-item__value">+91 1800-123-4567</span>
          </div>
        </div>
      </div>
      <p className="v2-help-pg-contact-hours">
        Available Mon-Fri, 9 AM - 6 PM IST
      </p>
    </div>
  );
};

export default HelpCenterContactInfo;
